import appConfig from '../../mobile/app.config.json';

export const appVersionLabel = `v${appConfig.version} (${appConfig.build})`;
export const APP_VERSION = appConfig.version;
export const APP_BUILD = appConfig.build;
